import { SET_SESSION_EXPIRED, SET_HAS_EXPRESS_DEAL } from './actionTypes'

export function setSessionExpired(sessionExpired = true) {
  return {
    type: SET_SESSION_EXPIRED,
    sessionExpired
  }
}

export function setHasExpressDeal(hasExpressDeal = true) {
  return {
    type: SET_HAS_EXPRESS_DEAL,
    hasExpressDeal
  }
}
